import { DatePicker } from "antd";
import styled from "styled-components";

export const StyledSalesDatePicker = styled(DatePicker)`
    width: 100%;
`;
